import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "device-mockup"
}
const _hoisted_2 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[450px] w-[250px] shadow-xl" }
const _hoisted_3 = { class: "rounded-[2rem] overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800" }
const _hoisted_4 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_5 = {
  key: 1,
  class: "device-mockup"
}
const _hoisted_6 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[450px] w-[250px] shadow-xl" }
const _hoisted_7 = { class: "rounded-[2rem] overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800" }
const _hoisted_8 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_9 = {
  key: 2,
  class: "device-mockup"
}
const _hoisted_10 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[450px] w-[250px] shadow-xl" }
const _hoisted_11 = { class: "rounded-[2rem] overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800" }
const _hoisted_12 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_13 = {
  key: 3,
  class: "device-mockup"
}
const _hoisted_14 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-xl h-[450px] w-[250px] shadow-xl" }
const _hoisted_15 = { class: "rounded-xl overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800" }
const _hoisted_16 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_17 = {
  key: 4,
  class: "device-mockup"
}
const _hoisted_18 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[350px] w-[280px] md:h-[400px] md:w-[320px] shadow-xl" }
const _hoisted_19 = { class: "rounded-[2rem] overflow-hidden h-[322px] w-[252px] md:h-[372px] md:w-[292px] bg-white dark:bg-gray-800" }
const _hoisted_20 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_21 = {
  key: 5,
  class: "device-mockup"
}
const _hoisted_22 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[8px] rounded-t-xl h-[150px] w-[240px] sm:h-[200px] sm:w-[320px] md:h-[320px] md:w-[520px] shadow-xl" }
const _hoisted_23 = { class: "rounded-lg overflow-hidden h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] bg-white dark:bg-gray-800" }
const _hoisted_24 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_25 = {
  key: 6,
  class: "device-mockup"
}
const _hoisted_26 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[8px] sm:border-[12px] md:border-[16px] rounded-t-xl h-[168px] w-[270px] sm:h-[224px] sm:w-[360px] md:h-[350px] md:w-[560px] shadow-xl" }
const _hoisted_27 = { class: "rounded-xl overflow-hidden h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px]" }
const _hoisted_28 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_29 = {
  key: 7,
  class: "device-mockup"
}
const _hoisted_30 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[4px] sm:border-[6px] md:border-[12px] rounded-t-lg h-[90px] w-[270px] sm:h-[120px] sm:w-[360px] md:h-[250px] md:w-[750px] shadow-xl" }
const _hoisted_31 = { class: "rounded-lg overflow-hidden h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] bg-white dark:bg-gray-800" }
const _hoisted_32 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_33 = {
  key: 8,
  class: "device-mockup"
}
const _hoisted_34 = { class: "relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[8px] sm:border-[12px] md:border-[16px] rounded-lg h-[168px] w-[288px] sm:h-[224px] sm:w-[384px] md:h-[320px] md:w-[560px] shadow-xl" }
const _hoisted_35 = { class: "rounded-md overflow-hidden h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] bg-white dark:bg-gray-800" }
const _hoisted_36 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}
const _hoisted_37 = {
  key: 9,
  class: "device-mockup"
}
const _hoisted_38 = { class: "relative mx-auto border-gray-900 dark:bg-gray-800 dark:border-gray-800 border-[10px] rounded-[2.5rem] h-[213px] w-[208px] shadow-xl" }
const _hoisted_39 = { class: "rounded-[2rem] overflow-hidden h-[193px] w-[188px]" }
const _hoisted_40 = {
  key: 0,
  class: "text-center mt-4 text-gray-600 dark:text-gray-400"
}

import { defineAsyncComponent, computed } from 'vue'
interface Props {
  deviceType: 'phone' | 'iphone' | 'iphone-pro' | 'android' | 'tablet' | 'laptop' | 'desktop' | 'ultrawide' | 'tv' | 'watch'
  wallpaper: string
  videoUrl?: string
  wallpaperId?: string
  resolution?: string
  name?: string
  showLabel?: boolean
  clickable?: boolean
  fitOption?: string
  scale?: number
}

interface Emits {
  (e: 'click'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceMockup',
  props: {
    deviceType: {},
    wallpaper: {},
    videoUrl: {},
    wallpaperId: {},
    resolution: {},
    name: {},
    showLabel: { type: Boolean, default: true },
    clickable: { type: Boolean, default: false },
    fitOption: { default: 'fill' },
    scale: { default: 1 }
  },
  emits: ["click"],
  setup(__props: any) {

const SimpleSecureImage = defineAsyncComponent(() => import('./SimpleSecureImage.vue'))

const props = __props



const displayWallpaperUrl = computed(() => {
  // Prefer a stored static poster/thumbnail for live wallpapers.
  // Fall back to the video URL only when no static preview exists.
  if (props.wallpaper?.trim()) {
    return props.wallpaper
  }

  return props.videoUrl?.trim() ? props.videoUrl : ''
})

// Function to get the appropriate CSS classes and styles based on fit option
const getImageClasses = (baseClasses: string) => {
  const fitClasses = {
    fill: 'object-cover',
    fit: 'object-contain',
    stretch: 'object-fill',
    tile: '', // Special handling for tile
    center: '', // Special handling for center
    span: 'object-cover',
    auto: '' // handled below
  }

  let fitClass = fitClasses[props.fitOption as keyof typeof fitClasses] || 'object-cover'

  if (props.fitOption === 'auto') {
    // Heuristic: use contain for very wide screens or square when image is likely portrait
    // If resolution is available, compute aspect ratio
    const res = props.resolution?.toLowerCase().split('x')
    if (res && res.length === 2) {
      const w = parseInt(res[0]) || 0
      const h = parseInt(res[1]) || 0
      const ratio = w && h ? w / h : 1
      const deviceRatioMap: Record<Props['deviceType'], number> = {
        phone: 9/19.5,
        iphone: 9/19.5,
        'iphone-pro': 9/19.5,
        android: 9/20,
        tablet: 4/3,
        laptop: 16/10,
        desktop: 16/9,
        ultrawide: 21/9,
        tv: 16/9,
        watch: 1
      }
      const target = deviceRatioMap[props.deviceType] || 1
      const diff = Math.abs(ratio - target)
      // If wallpaper is much narrower than screen (portrait on landscape), use contain
      fitClass = ratio < target ? 'object-contain' : (diff < 0.08 ? 'object-cover' : 'object-cover')
    } else {
      // Fallback: contain for landscape devices to avoid bad crops
      fitClass = ['laptop','desktop','ultrawide','tv'].includes(props.deviceType) ? 'object-contain' : 'object-cover'
    }
  }

  if (props.fitOption === 'tile' || props.fitOption === 'center') {
    return `${baseClasses} cursor-pointer hover:opacity-90 transition-opacity`
  }

  return `${baseClasses} ${fitClass} cursor-pointer hover:opacity-90 transition-opacity`
}



// Function to get appropriate tile size based on device type
const getTileSize = () => {
  const deviceSizes = {
    phone: 80,
    iphone: 80,
    'iphone-pro': 80,
    android: 80,
    tablet: 120,
    laptop: 150,
    desktop: 180,
    ultrawide: 200,
    tv: 200,
    watch: 60
  }
  return deviceSizes[props.deviceType] || 100
}

// Return inline style object for background-based preview when wallpaperId is not provided
const getBackgroundStyle = () => {
  if (!props.wallpaper) return {}
  if (props.fitOption === 'tile') {
    const size = getTileSize()
    return {
      backgroundImage: `url(${props.wallpaper})`,
      backgroundRepeat: 'repeat',
      backgroundSize: `${size}px ${size}px`,
      backgroundPosition: 'top left'
    }
  }
  if (props.fitOption === 'center') {
    return {
      backgroundImage: `url(${props.wallpaper})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto',
      backgroundPosition: 'center'
    }
  }
  // Default: cover or contain depending on device type heuristics
  const contains = ['laptop','desktop','ultrawide','tv'].includes(props.deviceType)
  return {
    backgroundImage: `url(${props.wallpaper})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: contains ? 'contain' : 'cover',
    backgroundPosition: 'center'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "device-mockup-container",
    style: _normalizeStyle({ transform: `scale(${_ctx.scale})` })
  }, [
    (_ctx.deviceType === 'phone')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "h-[24px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[54px] rounded-s-lg" }, null, -1)),
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "h-[34px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg" }, null, -1)),
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "h-[34px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg" }, null, -1)),
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "h-[48px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.wallpaperId)
                ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                    key: 0,
                    "image-url": displayWallpaperUrl.value,
                    "wallpaper-id": _ctx.wallpaperId,
                    "is-preview": true,
                    "force-autoplay": true,
                    muted: true,
                    loop: true,
                    playsinline: true,
                    alt: _ctx.name || 'Phone wallpaper',
                    "container-class": 'w-[222px] h-[422px] rounded-[2rem]',
                    "image-class": getImageClasses('w-[222px] h-[422px]'),
                    "target-aspect": 222/422,
                    "target-width": 222,
                    "target-height": 422,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
                  }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                : (_ctx.wallpaper)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: _normalizeStyle(getBackgroundStyle()),
                      class: _normalizeClass(getImageClasses('w-[222px] h-[422px]')),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click')))
                    }, null, 6))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click')))
                    }, _cache[30] || (_cache[30] = [
                      _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                    ])))
            ])
          ]),
          (_ctx.showLabel)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.name || 'Phone'), 1))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.deviceType === 'iphone')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "w-[100px] h-[20px] bg-gray-900 top-0 rounded-b-[1.2rem] left-1/2 -translate-x-1/2 absolute z-20 shadow-inner border-b-2 border-gray-700" }, null, -1)),
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg" }, null, -1)),
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg" }, null, -1)),
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "h-[48px] w-[3px] bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg" }, null, -1)),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.wallpaperId)
                  ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                      key: 0,
                      "image-url": displayWallpaperUrl.value,
                      "wallpaper-id": _ctx.wallpaperId,
                      "is-preview": true,
                      "force-autoplay": true,
                      muted: true,
                      loop: true,
                      playsinline: true,
                      alt: _ctx.name || 'iPhone wallpaper',
                      "container-class": 'w-[222px] h-[422px] rounded-[2rem]',
                      "image-class": getImageClasses('w-[222px] h-[422px]'),
                      "target-aspect": 222/422,
                      "target-width": 222,
                      "target-height": 422,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click')))
                    }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                  : (_ctx.wallpaper)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle(getBackgroundStyle()),
                        class: _normalizeClass(getImageClasses('w-[222px] h-[422px]')),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click')))
                      }, null, 6))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('click')))
                      }, _cache[35] || (_cache[35] = [
                        _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                      ])))
              ])
            ]),
            (_ctx.showLabel)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.name || 'iPhone 12'), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.deviceType === 'iphone-pro')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg" }, null, -1)),
                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg" }, null, -1)),
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "h-[48px] w-[3px] bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg" }, null, -1)),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.wallpaperId)
                    ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                        key: 0,
                        "image-url": displayWallpaperUrl.value,
                        "wallpaper-id": _ctx.wallpaperId,
                        "is-preview": true,
                        "force-autoplay": true,
                        muted: true,
                        loop: true,
                        playsinline: true,
                        alt: _ctx.name || 'iPhone Pro wallpaper',
                        "container-class": 'w-[222px] h-[422px] rounded-[2rem]',
                        "image-class": getImageClasses('w-[222px] h-[422px]'),
                        "target-aspect": 222/422,
                        "target-width": 222,
                        "target-height": 422,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('click')))
                      }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                    : (_ctx.wallpaper)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          style: _normalizeStyle(getBackgroundStyle()),
                          class: _normalizeClass(getImageClasses('w-[222px] h-[422px]')),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('click')))
                        }, null, 6))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('click')))
                        }, _cache[40] || (_cache[40] = [
                          _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                        ])))
                ]),
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "w-[80px] h-[24px] bg-gray-800 top-[8px] rounded-full left-1/2 -translate-x-1/2 absolute z-20 pointer-events-none" }, null, -1))
              ]),
              (_ctx.showLabel)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.name || 'iPhone Pro'), 1))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.deviceType === 'android')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"w-[120px] h-[14px] bg-gray-800 top-0 rounded-b-[1rem] left-1/2 -translate-x-1/2 absolute\" data-v-06bce7fb></div><div class=\"h-[24px] w-[3px] bg-gray-800 absolute -start-[17px] top-[54px] rounded-s-lg\" data-v-06bce7fb></div><div class=\"h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg\" data-v-06bce7fb></div><div class=\"h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg\" data-v-06bce7fb></div><div class=\"h-[48px] w-[3px] bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg\" data-v-06bce7fb></div>", 5)),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.wallpaperId)
                      ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                          key: 0,
                          "image-url": displayWallpaperUrl.value,
                          "wallpaper-id": _ctx.wallpaperId,
                          "is-preview": true,
                          "force-autoplay": true,
                          muted: true,
                          loop: true,
                          playsinline: true,
                          alt: _ctx.name || 'Android wallpaper',
                          "container-class": 'w-[222px] h-[422px] rounded-xl',
                          "image-class": getImageClasses('w-[222px] h-[422px]'),
                          "target-aspect": 222/422,
                          "target-width": 222,
                          "target-height": 422,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('click')))
                        }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                      : (_ctx.wallpaper)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle(getBackgroundStyle()),
                            class: _normalizeClass(getImageClasses('w-[222px] h-[422px]')),
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('click')))
                          }, null, 6))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-xl",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('click')))
                          }, _cache[45] || (_cache[45] = [
                            _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                          ])))
                  ])
                ]),
                (_ctx.showLabel)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.name || 'Android'), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.deviceType === 'tablet')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "h-[24px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[50px] rounded-s-lg" }, null, -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[86px] rounded-s-lg" }, null, -1)),
                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[124px] rounded-s-lg" }, null, -1)),
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "h-[44px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[99px] rounded-e-lg" }, null, -1)),
                    _createElementVNode("div", _hoisted_19, [
                      (_ctx.wallpaperId)
                        ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                            key: 0,
                            "image-url": displayWallpaperUrl.value,
                            "wallpaper-id": _ctx.wallpaperId,
                            "is-preview": true,
                            "force-autoplay": true,
                            muted: true,
                            loop: true,
                            playsinline: true,
                            alt: _ctx.name || 'Tablet wallpaper',
                            "container-class": 'h-[322px] w-[252px] md:h-[372px] md:w-[292px] rounded-[2rem]',
                            "image-class": getImageClasses('h-[322px] w-[252px] md:h-[372px] md:w-[292px]'),
                            "target-aspect": 252/322,
                            "target-width": 292,
                            "target-height": 372,
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('click')))
                          }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                        : (_ctx.wallpaper)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              style: _normalizeStyle(getBackgroundStyle()),
                              class: _normalizeClass(getImageClasses('h-[322px] w-[252px] md:h-[372px] md:w-[292px]')),
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('click')))
                            }, null, 6))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "h-[322px] w-[252px] md:h-[372px] md:w-[292px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('click')))
                            }, _cache[47] || (_cache[47] = [
                              _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                            ])))
                    ])
                  ]),
                  (_ctx.showLabel)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.name || 'Tablet'), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.deviceType === 'laptop')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          (_ctx.wallpaperId)
                            ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                                key: 0,
                                "image-url": displayWallpaperUrl.value,
                                "wallpaper-id": _ctx.wallpaperId,
                                "is-preview": true,
                                "force-autoplay": true,
                                muted: true,
                                loop: true,
                                playsinline: true,
                                alt: _ctx.name || 'Laptop wallpaper',
                                "container-class": 'h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] rounded-lg',
                                "image-class": getImageClasses('h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] rounded-lg'),
                                "target-aspect": 504/304,
                                "target-width": 504,
                                "target-height": 304,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('click')))
                              }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                            : (_ctx.wallpaper)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  style: _normalizeStyle(getBackgroundStyle()),
                                  class: _normalizeClass(getImageClasses('h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] rounded-lg')),
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('click')))
                                }, null, 6))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-lg",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('click')))
                                }, _cache[52] || (_cache[52] = [
                                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                                ])))
                        ])
                      ]),
                      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "relative mx-auto bg-gray-900 dark:bg-gray-700 rounded-b-xl rounded-t-sm h-[12px] w-[270px] sm:h-[15px] sm:w-[360px] md:h-[21px] md:w-[580px]" }, [
                        _createElementVNode("div", { class: "absolute left-1/2 top-0 -translate-x-1/2 rounded-b-xl w-[48px] h-[3px] sm:w-[64px] sm:h-[4px] md:w-[120px] md:h-[8px] bg-gray-800" })
                      ], -1))
                    ]),
                    (_ctx.showLabel)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.name || 'Laptop'), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.deviceType === 'desktop')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (_ctx.wallpaperId)
                              ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                                  key: 0,
                                  "image-url": displayWallpaperUrl.value,
                                  "wallpaper-id": _ctx.wallpaperId,
                                  "is-preview": true,
                                  "force-autoplay": true,
                                  muted: true,
                                  loop: true,
                                  playsinline: true,
                                  alt: _ctx.name || 'Desktop wallpaper',
                                  "container-class": 'h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] rounded-xl',
                                  "image-class": getImageClasses('h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] rounded-xl'),
                                  "target-aspect": 528/318,
                                  "target-width": 528,
                                  "target-height": 318,
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('click')))
                                }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                              : (_ctx.wallpaper)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    style: _normalizeStyle(getBackgroundStyle()),
                                    class: _normalizeClass(getImageClasses('h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] rounded-xl')),
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('click')))
                                  }, null, 6))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-xl",
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('click')))
                                  }, _cache[54] || (_cache[54] = [
                                    _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                                  ])))
                          ])
                        ]),
                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "relative mx-auto bg-gray-900 dark:bg-gray-700 rounded-b-xl h-[18px] w-[270px] sm:h-[25px] sm:w-[360px] md:h-[42px] md:w-[560px]" }, null, -1)),
                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "relative mx-auto bg-gray-800 rounded-b-xl h-[36px] w-[72px] sm:h-[48px] sm:w-[96px] md:h-[80px] md:w-[160px]" }, null, -1))
                      ]),
                      (_ctx.showLabel)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.name || 'Desktop'), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.deviceType === 'ultrawide')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              (_ctx.wallpaperId)
                                ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                                    key: 0,
                                    "image-url": displayWallpaperUrl.value,
                                    "wallpaper-id": _ctx.wallpaperId,
                                    "is-preview": true,
                                    "force-autoplay": true,
                                    muted: true,
                                    loop: true,
                                    playsinline: true,
                                    alt: _ctx.name || 'Ultrawide wallpaper',
                                    "container-class": 'h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] rounded-lg',
                                    "image-class": getImageClasses('h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] rounded-lg'),
                                    "target-aspect": 726/226,
                                    "target-width": 726,
                                    "target-height": 226,
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('click')))
                                  }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                                : (_ctx.wallpaper)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      style: _normalizeStyle(getBackgroundStyle()),
                                      class: _normalizeClass(getImageClasses('h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] rounded-lg')),
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('click')))
                                    }, null, 6))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      class: "h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-lg",
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('click')))
                                    }, _cache[57] || (_cache[57] = [
                                      _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                                    ])))
                            ])
                          ]),
                          _cache[58] || (_cache[58] = _createElementVNode("div", { class: "relative mx-auto bg-gray-900 dark:bg-gray-700 rounded-b-lg h-[12px] w-[270px] sm:h-[15px] sm:w-[360px] md:h-[30px] md:w-[750px]" }, null, -1)),
                          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "relative mx-auto bg-gray-800 rounded-b-lg h-[24px] w-[45px] sm:h-[30px] sm:w-[60px] md:h-[60px] md:w-[120px]" }, null, -1))
                        ]),
                        (_ctx.showLabel)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.name || 'Ultrawide Monitor'), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.deviceType === 'tv')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                (_ctx.wallpaperId)
                                  ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                                      key: 0,
                                      "image-url": displayWallpaperUrl.value,
                                      "wallpaper-id": _ctx.wallpaperId,
                                      "is-preview": true,
                                      "force-autoplay": true,
                                      muted: true,
                                      loop: true,
                                      playsinline: true,
                                      alt: _ctx.name || 'TV wallpaper',
                                      "container-class": 'h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] rounded-md',
                                      "image-class": getImageClasses('h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] rounded-md'),
                                      "target-aspect": 528/288,
                                      "target-width": 528,
                                      "target-height": 288,
                                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('click')))
                                    }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                                  : (_ctx.wallpaper)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        style: _normalizeStyle(getBackgroundStyle()),
                                        class: _normalizeClass(getImageClasses('h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] rounded-md')),
                                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('click')))
                                      }, null, 6))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-md",
                                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('click')))
                                      }, _cache[60] || (_cache[60] = [
                                        _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                                      ])))
                              ]),
                              _cache[61] || (_cache[61] = _createElementVNode("div", { class: "absolute bottom-1 right-1 w-1.5 h-1.5 sm:bottom-2 sm:right-2 sm:w-2 sm:h-2 bg-red-500 rounded-full opacity-80" }, null, -1))
                            ]),
                            _cache[62] || (_cache[62] = _createStaticVNode("<div class=\"relative mx-auto bg-gray-800 dark:bg-gray-700 h-[5px] w-[288px] sm:h-[6px] sm:w-[384px] md:h-[10px] md:w-[560px]\" data-v-06bce7fb></div><div class=\"relative mx-auto\" data-v-06bce7fb><div class=\"mx-auto bg-gray-800 dark:bg-gray-700 h-[7px] w-[192px] sm:h-[9px] sm:w-[256px] md:h-[15px] md:w-[380px] rounded-b-lg\" data-v-06bce7fb></div><div class=\"flex justify-between mx-auto w-[192px] sm:w-[256px] md:w-[380px] mt-1\" data-v-06bce7fb><div class=\"bg-gray-800 dark:bg-gray-700 h-[15px] w-[36px] sm:h-[20px] sm:w-[48px] md:h-[30px] md:w-[80px] rounded-b-md\" data-v-06bce7fb></div><div class=\"bg-gray-800 dark:bg-gray-700 h-[15px] w-[36px] sm:h-[20px] sm:w-[48px] md:h-[30px] md:w-[80px] rounded-b-md\" data-v-06bce7fb></div></div></div>", 2))
                          ]),
                          (_ctx.showLabel)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.name || 'Smart TV'), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.deviceType === 'watch')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("div", null, [
                              _cache[66] || (_cache[66] = _createElementVNode("div", { class: "relative mx-auto bg-gray-800 dark:bg-gray-700 rounded-t-[2.5rem] h-[63px] max-w-[133px]" }, null, -1)),
                              _createElementVNode("div", _hoisted_38, [
                                _cache[64] || (_cache[64] = _createElementVNode("div", { class: "h-[41px] w-[6px] bg-gray-800 dark:bg-gray-800 absolute -end-[16px] top-[40px] rounded-e-lg" }, null, -1)),
                                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "h-[32px] w-[6px] bg-gray-800 dark:bg-gray-800 absolute -end-[16px] top-[88px] rounded-e-lg" }, null, -1)),
                                _createElementVNode("div", _hoisted_39, [
                                  (_ctx.wallpaperId)
                                    ? (_openBlock(), _createBlock(_unref(SimpleSecureImage), {
                                        key: 0,
                                        "image-url": displayWallpaperUrl.value,
                                        "wallpaper-id": _ctx.wallpaperId,
                                        "is-preview": true,
                                        "force-autoplay": true,
                                        muted: true,
                                        loop: true,
                                        playsinline: true,
                                        alt: _ctx.name || 'Watch wallpaper',
                                        "container-class": 'h-[193px] w-[188px] rounded-[2rem]',
                                        "image-class": getImageClasses('h-[193px] w-[188px]'),
                                        "target-aspect": 188/193,
                                        "target-width": 188,
                                        "target-height": 193,
                                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('click')))
                                      }, null, 8, ["image-url", "wallpaper-id", "alt", "image-class"]))
                                    : (_ctx.wallpaper)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          style: _normalizeStyle(getBackgroundStyle()),
                                          class: _normalizeClass(getImageClasses('h-[193px] w-[188px]')),
                                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('click')))
                                        }, null, 6))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "h-[193px] w-[188px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]",
                                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('click')))
                                        }, _cache[63] || (_cache[63] = [
                                          _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 text-sm" }, "No Preview", -1)
                                        ])))
                                ])
                              ]),
                              _cache[67] || (_cache[67] = _createElementVNode("div", { class: "relative mx-auto bg-gray-800 dark:bg-gray-700 rounded-b-[2.5rem] h-[63px] max-w-[133px]" }, null, -1))
                            ]),
                            (_ctx.showLabel)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.name || 'Smartwatch'), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
  ], 4))
}
}

})